// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainLogin {
    position: relative;
    max-width: 1280px;
    height: calc(100% - 64px);
    margin: 64px auto 0 auto;
    padding: 0 50px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}

.contentLogin {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 40px;
    margin-bottom: 45px;
}

.imgLogoLogin {
    width: 100%;
}

.formLogin {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #FFF4D9;
    border-radius: 16px;
    padding: 20px 34px;
}

.formLogin h2 {
    color: #4B2D10;
    font-weight: 500;
    font-size: 32px;
    margin-bottom: 48px;
}

.fieldsFormLog {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 38px;
    margin-bottom: 22px;
}

.contInputField {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
}

.inputFormLog {
    position: relative;
    width: 100%;
    border: none;
    outline: none;
    background-color: transparent;
    font-family: Alegreya Sans;
    color: #4B2D10;
    font-size: 20px;
    appearance: none;
    border-bottom: 1px #B48100 solid;
    padding-right: 27px;
}

.inputFormLog::placeholder {
    color: #4B2D10;
}

.iconCheck {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
}

.rememberBlock {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #4B2D10;
    font-size: 14px;
    /* line-height: 100%; */
    margin-bottom: 38px;
}

.checkboxLabel {
    position: relative;
    display: flex;
    align-items: center;
    gap: 11px;
}

.checkboxInput {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

.checkboxCustom {
    display: inline-block;
    width: 17px;
    height: 17px;
    border: 1.5px solid #B48100;
    border-radius: 4px;
    transition: all 0.2s ease-in-out;
    position: relative;
}

/* Стили для состояния checked */
.checkboxInput:checked ~ .checkboxCustom {
    background-color: #B48100;
}

/* Галочка через ::after */
.checkboxInput:checked ~ .checkboxCustom::after {
    content: "";
    position: absolute;
    top: 0;
    left: 30%;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}

.checkboxText {
    margin-top: 3px;
}

.forgotPassword {
    text-decoration: underline;
    color: inherit;
}

.buttonsBlock {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 13px;
}

.buttonLog {
    width: 100%;
    height: 44px;
    background: #FFB800;
    padding: 10px 20px;
    margin: 0 auto;
    border-radius: 8px;
    border: none;
    font-size: 20px;
    color: #4B2D10;
    font-weight: 500;
    font-family: Alegreya Sans;
    cursor: pointer;
    margin-top: 10px;
}

.buttonsBlock a {
    color: #4B2D10;
    font-size: 16px;
    text-decoration: underline;
}

.imgPeopleLog {
    width: 87%;
}

@media (min-width: 640px) {
    .imgLogoLogin {
        width: 80%;
        margin: 0 auto;
    }
}

@media (min-width: 768px) {
    .contentLogin {
        gap: 50px;
    }

    .imgLogoLogin {
        max-width: 500px;
    }

    .formLogin {
        width: 90%;
        margin: 0 auto;
    }

    .imgLogoLogin {
        width: 60%;
    }

    .formLogin h2 {
        font-size: 36px;
    }

    .buttonLog {
        width: max-content;
        height: 50px;
        font-size: 24px;
        padding: 10px 64px;
    }

    .inputFormLog {
        font-size: 24px;
    }

    .rememberBlock {
        font-size: 18px;
    }

    .checkboxCustom {
        width: 20px;
        height: 20px;
    }

    .buttonsBlock a {
        font-size: 20px;
    }

    .imgPeopleLog {
        width: 65%;
    }
}

@media (min-width: 1024px) {
    .imgLogoLogin {
        max-width: 400px;
    }

    .formLogin {
        width: 70%;
    }

    .imgPeopleLog {
        width: 50%;
    }
}

@media (min-width: 1152px) {
    .formLogin {
        width: 50%;
    }
}

@media (min-width: 1280px) {
    .imgPeopleLog {
        width: 40%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Login/Login.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,wBAAwB;IACxB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,0BAA0B;IAC1B,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA,gCAAgC;AAChC;IACI,yBAAyB;AAC7B;;AAEA,0BAA0B;AAC1B;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,UAAU;QACV,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,cAAc;IAClB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ","sourcesContent":[".mainLogin {\n    position: relative;\n    max-width: 1280px;\n    height: calc(100% - 64px);\n    margin: 64px auto 0 auto;\n    padding: 0 50px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.contentLogin {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n    margin-bottom: 45px;\n}\n\n.imgLogoLogin {\n    width: 100%;\n}\n\n.formLogin {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background-color: #FFF4D9;\n    border-radius: 16px;\n    padding: 20px 34px;\n}\n\n.formLogin h2 {\n    color: #4B2D10;\n    font-weight: 500;\n    font-size: 32px;\n    margin-bottom: 48px;\n}\n\n.fieldsFormLog {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 38px;\n    margin-bottom: 22px;\n}\n\n.contInputField {\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.inputFormLog {\n    position: relative;\n    width: 100%;\n    border: none;\n    outline: none;\n    background-color: transparent;\n    font-family: Alegreya Sans;\n    color: #4B2D10;\n    font-size: 20px;\n    appearance: none;\n    border-bottom: 1px #B48100 solid;\n    padding-right: 27px;\n}\n\n.inputFormLog::placeholder {\n    color: #4B2D10;\n}\n\n.iconCheck {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 0;\n}\n\n.rememberBlock {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    color: #4B2D10;\n    font-size: 14px;\n    /* line-height: 100%; */\n    margin-bottom: 38px;\n}\n\n.checkboxLabel {\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 11px;\n}\n\n.checkboxInput {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0;\n}\n\n.checkboxCustom {\n    display: inline-block;\n    width: 17px;\n    height: 17px;\n    border: 1.5px solid #B48100;\n    border-radius: 4px;\n    transition: all 0.2s ease-in-out;\n    position: relative;\n}\n\n/* Стили для состояния checked */\n.checkboxInput:checked ~ .checkboxCustom {\n    background-color: #B48100;\n}\n\n/* Галочка через ::after */\n.checkboxInput:checked ~ .checkboxCustom::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 30%;\n    width: 5px;\n    height: 10px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg);\n}\n\n.checkboxText {\n    margin-top: 3px;\n}\n\n.forgotPassword {\n    text-decoration: underline;\n    color: inherit;\n}\n\n.buttonsBlock {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 13px;\n}\n\n.buttonLog {\n    width: 100%;\n    height: 44px;\n    background: #FFB800;\n    padding: 10px 20px;\n    margin: 0 auto;\n    border-radius: 8px;\n    border: none;\n    font-size: 20px;\n    color: #4B2D10;\n    font-weight: 500;\n    font-family: Alegreya Sans;\n    cursor: pointer;\n    margin-top: 10px;\n}\n\n.buttonsBlock a {\n    color: #4B2D10;\n    font-size: 16px;\n    text-decoration: underline;\n}\n\n.imgPeopleLog {\n    width: 87%;\n}\n\n@media (min-width: 640px) {\n    .imgLogoLogin {\n        width: 80%;\n        margin: 0 auto;\n    }\n}\n\n@media (min-width: 768px) {\n    .contentLogin {\n        gap: 50px;\n    }\n\n    .imgLogoLogin {\n        max-width: 500px;\n    }\n\n    .formLogin {\n        width: 90%;\n        margin: 0 auto;\n    }\n\n    .imgLogoLogin {\n        width: 60%;\n    }\n\n    .formLogin h2 {\n        font-size: 36px;\n    }\n\n    .buttonLog {\n        width: max-content;\n        height: 50px;\n        font-size: 24px;\n        padding: 10px 64px;\n    }\n\n    .inputFormLog {\n        font-size: 24px;\n    }\n\n    .rememberBlock {\n        font-size: 18px;\n    }\n\n    .checkboxCustom {\n        width: 20px;\n        height: 20px;\n    }\n\n    .buttonsBlock a {\n        font-size: 20px;\n    }\n\n    .imgPeopleLog {\n        width: 65%;\n    }\n}\n\n@media (min-width: 1024px) {\n    .imgLogoLogin {\n        max-width: 400px;\n    }\n\n    .formLogin {\n        width: 70%;\n    }\n\n    .imgPeopleLog {\n        width: 50%;\n    }\n}\n\n@media (min-width: 1152px) {\n    .formLogin {\n        width: 50%;\n    }\n}\n\n@media (min-width: 1280px) {\n    .imgPeopleLog {\n        width: 40%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
